module.exports = __webpack_public_path__ + "img/exam_jan_2025_c38j3pu2.f9f06b4d.jpg";